import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './theme/index.less'
import ElementPlus from 'element-plus'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/lib/theme-chalk/index.css'

const app = createApp(App)

app.use(store).use(router).use(ElementPlus, { locale }).mount('#app')
